<template>
  <div class="masteradmin">
    <header>
      <div class="navbar-fixed">
      <nav>
        <div class="nav-wrapper">
          <div class="row">
            <div class="col s12">
              <a href="#" data-target="sidenav-1" class="left sidenav-trigger hide-on-medium-and-up">
                <i class="material-icons">menu</i>
              </a>
              <h5 class="headerTitle desktopHeader">Assam Power Distribution Company Limited</h5>
              <h5 class="mobileHeader">Welcome to APDCL</h5>
            </div>
          </div>
        </div>
      </nav>
    </div>
    </header>
    <ul id="sidenav-1" class="sidenav sidenav-fixed">
      <li class="sidenav-header" style="background-color:#01579b;">
        <div class="row">
          <div class="col s12">
              <h6 style="color:white;">Welcome Admin</h6>
          </div>
        </div>
      </li>
      <li><router-link class="waves-effect textAlign" to="/usercreate">
        <i class="material-icons iconShift">person_add</i>Create User</router-link></li>
      <li ><router-link class="waves-effect textAlign" to="">
        <i class="material-icons iconShift">person_pin</i>Update User</router-link></li>
      <li class="active"><router-link class="waves-effect textAlign" to="/viewusers">
        <i class="material-icons iconShift">group</i>View Users</router-link></li>
      <!--<li><router-link class="waves-effect textAlign" to="/career">
        <i class="material-icons iconShift">portrait</i>Career</router-link></li> -->

        <div class="footer-fixed">
          <footer class="footerstyle">
            <div class="footer-copyright">
              <div class="container" style="font-size:11px; text-align:center;">
              © 2020 Copyright Assam Power Distribution Company Limited, Developed by IT Cell, APDCL.
              </div>
            </div>
          </footer>
        </div>
    </ul>

    <main>
      <br>
      <!-- <div class="container"> -->
        <div class="row">
          <div class="col m12" style="margin-left: -14px;">
            <table>
               <thead>
                 <tr>
                    <th>Sl. No.</th>
                    <th>ERP Id</th>
                    <th>User Name</th>
                    <th>Office</th>
                    <th>Designation</th>
                    <th>Mobile No.</th>
                    <th>Email Id</th>
                    <th>Active Flag</th>
                    <!-- <th>Creation Date</th> -->
                    <th>Created By</th>
                </tr>
               </thead>
               <tbody v-if="rolesToDisplay.length > 0">
                <tr v-for="item in rolesToDisplay">
                  <td style="text-align: center;"></td>
                  <td>{{item[0]}}</td>
                  <td>{{item[1]}}</td>
                  <td>{{item[2]}}</td>
                  <td>{{item[3]}}</td>
                  <td>{{item[4]}}</td>
                  <td>{{item[5]}}</td>
                  <td style="text-align: center;">{{item[6]}}</td>
                  <td style="border-right: solid 1px black;">{{item[7]}}</td>
                </tr>
               </tbody>
            </table>
          </div>
      </div>
      <!-- </div> -->
    </main>
  </div>
</template>

<script>
import axios from 'axios';
// var rolesToSend = [];

  export default{

    data: function () {
      return {
        rolesToDisplay: []
      }
    },
    mounted(){
      var elems = document.querySelectorAll('.sidenav');
      var instances = M.Sidenav.init(elems, {});

      const PARENT = this;
      axios.get("http://localhost:8082/website/api/admin/showusers").then(function(response) {
        PARENT.rolesToDisplay = response.data
      })
    },
    methods:{
      }
    }

</script>


<style scoped="true">
.modal{
  overflow-y:hidden !important;
}

  /* header, footer {
    padding-left: 300px;
  } */
  main{
    padding-left: 350px;
  }
  .headerTitle{
    padding-left: 250px;
  }
  .mobileHeader{
    display: none;
  }
  .desktopHeader{
    display:block;
  }

  .sidenav-header {
    /* background: url("../images/user-bg.jpg") no-repeat center center; */
    background-size: cover;
    margin-bottom: 0px;
    padding: 18px 0 0 18px;
    height: 64px;
      .row {
        margin-bottom: 0;
      }
    }

    .nav-wrapper{
      background-color: #01579b ;
    }

    .paddingTop{
      padding-top: 1.5rem !important;
    }

    /* input[type=text]{
      color:black !important;
      border-bottom: 1px solid #9e9e9e !important;
    } */

    .textAlign{
      text-align: left;
    }

    .iconShift{
      margin:0px !important;
      padding: 0px 42px !important;
    }

    .star{
      color:red;
    }

    .paddingCheckboxTop{
      padding-top: .8rem !important;
    }

    .left{
      text-align: left;
    }

    .footerstyle{
      position: absolute;
      top: calc(100vh - 57px);
    }

    table {
      border-collapse: separate;
      border-spacing: 0;
      width: 100%;
      font-size: 11px;
      counter-reset: rowNumber-1;
    }
    table tr {
      counter-increment: rowNumber;
    }
    table tr td:first-child::before {
      content: counter(rowNumber);
      /* min-width: 1em;
      margin-right: 0.5em; */
    }
    th{
      padding: 6px 15px;
      font-size:small;
    }
    th{
      padding: -20px 0px -25px 20px;
      font-size:small;
      text-align: center;
    }
    th {
      background: #01579b;
      color: #fff;
      text-align: center;
    }
    tr:first-child th:first-child {
      /* border-top-left-radius: 6px; */
    }
    tr:first-child th:last-child {
      /* border-top-right-radius: 6px; */
    }
    th {
      border-right: 1px solid #c6c9cc;
      border-bottom: 1px solid #c6c9cc;
    }
    th:first-child {
      border-left: 1px solid #c6c9cc;
    }
    tr:nth-child(even) th {
      background: #eaeaed;
    }
    tr:last-child th:first-child {
      /* border-bottom-left-radius: 6px; */
    }
    tr:last-child th:last-child {
      /* border-bottom-right-radius: 6px; */
    }
    td{
      border-left: solid 1px black;
      border-bottom: solid 1px black;
    }


  @media only screen and (max-width : 992px) {
    header, main, footer {
      padding-left: 0 !important;
    }
    .headerTitle{
      padding-left: 0;
    }
    .mobileHeader{
      display: block;
    }
    .desktopHeader{
      display:none;
    }
    .paddingTop{
      padding-top: 0 !important;
    }
  }
</style>
